import { Box, Link } from '@mui/material'
import { FoxModalDialog } from '../../../components/common/FoxModalDialog'
import { FoxTypography } from '../../../components/common/FoxTypography'
import { FoxButton } from '../../../components/common/FoxButton'
import { AccountRequirementsModalProps } from '../../../containers/account/AccountRequirementsModal'
import { DomainCommonName } from '@foxtail-dev/datacontracts'
import { Domains } from '@foxtail-dev/datacontracts/dist/lib/schemas/Domains'

type AreYouSureYouWantToSignOutModalProps = {
    open: boolean
    onClose: (isConfirmed: boolean) => void
}

export const ExtensionReloadModal = ({ open, onClose }: AreYouSureYouWantToSignOutModalProps) => {
    return (
        <FoxModalDialog
            open={open}
            title={'Reload page for extension'}
            leftButtonKind={'close'}
            onClose={() => {
                location.reload()
                onClose(false)
            }}
            closeOnBackdropClick
        >
            <Box sx={{ textAlign: 'center', width: '100%' }}>
                <FoxTypography variant='subtitle1' sx={{ marginBottom: '40px', marginTop: '40px' }}>
                    To finish the extension installation you must reload the page
                </FoxTypography>

                <FoxButton
                    primary
                    onFoxClick={{
                        kind: 'button',
                        onClick: async () => {
                            location.reload()
                            onClose(true)
                        }
                    }}
                    text={'Reload'}
                    sx={{ marginTop: '24px', width: '100%', justifyContent: 'center' }}
                />
            </Box>
        </FoxModalDialog>
    )
}
